import { render, staticRenderFns } from "./BTime.vue?vue&type=template&id=461c5a2f&"
import script from "./BTime.vue?vue&type=script&lang=js&"
export * from "./BTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports